import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import CircularProgressBar from "../assets/CircularProgressBar";
import { useDarkMode } from "../assets/DarkModeContext";

export function Evaluation() {
    const { isDarkMode } = useDarkMode();

    return (
        <div>
            <h2
                className={ `text-center py-2 ${ isDarkMode ? "text-white" : "" }` }
            >
                Evaluation des performances
            </h2>
            <div className="row">
                <div className="col-12 col-md-6 py-5">
                    <CircularProgressBar/>
                </div>

                <div className="col-12 col-md-6 shadow-4 rounded-5 mt-4">
                    <div className="d-flex justify-content-around">
                        <p className="pt-2" style={ { color: "#09B4BF" } }>
                            Client :
                        </p>
                        <p className="pt-2" style={ { color: "#09B4BF" } }>
                            Période :
                        </p>
                    </div>
                    <MDBTable>
                        <MDBTableHead
                            className={ `${ isDarkMode ? "bg-dark-mode" : "" }` }
                        >
                            <tr style={ { color: "#09B4BF" } }>
                                <th className="">Evaluation</th>
                                <th className="">Note Correspondante</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody style={ { verticalAlign: "middle" } }>
                            <tr className={ isDarkMode ? "text-white" : "text-muted" }>
                                <td>
                                    <div>
                                        <p>Ponctualité</p>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <p>10</p>
                                    </div>
                                </td>
                            </tr>
                            <tr className={ isDarkMode ? "text-white" : "text-muted" }>
                                <td>
                                    <div>
                                        <p>Connaissances et compétences professionnelles</p>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <p>10</p>
                                    </div>
                                </td>
                            </tr>
                            <tr className={ isDarkMode ? "text-white" : "text-muted" }>
                                <td>
                                    <div>
                                        <p>Sens du collectif et coopération</p>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <p>10</p>
                                    </div>
                                </td>
                            </tr>
                            <tr className={ isDarkMode ? "text-white" : "text-muted" }>
                                <td>
                                    <div>
                                        <p>Capacité de résolution de problèmes</p>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <p>10</p>
                                    </div>
                                </td>
                            </tr>
                        </MDBTableBody>
                    </MDBTable>
                </div>
            </div>
        </div>
    );
}
